import axios from 'axios'
import { CoinData } from './types'

export const formatPrice = (price: number): string => {
  if (price >= 1000) return `$${price.toLocaleString('en-US', { maximumFractionDigits: 2 })}`
  if (price >= 1) return `$${price.toLocaleString('en-US', { maximumFractionDigits: 4 })}`
  return `$${price.toLocaleString('en-US', { maximumFractionDigits: 8 })}`
}

export const formatCurrency = (amount: number): string =>
  `$${amount.toLocaleString('en-US', { maximumFractionDigits: 0 })}`

export const formatNumber = (num: number): string =>
  num.toLocaleString('en-US', { maximumFractionDigits: 0 })

export const fetchCryptoData = async (
  coinId: string,
  setData: (data: CoinData) => void,
  setError: (error: string | null) => void,
  setLoading: (loading: boolean) => void,
  setRefreshing: (refreshing: boolean) => void
) => {
  try {
    setRefreshing(true)
    const response = await axios.get(
      `https://api.coingecko.com/api/v3/coins/${coinId}?localization=false&tickers=false&market_data=true&community_data=true&developer_data=true&sparkline=false&localization=en`
    )
    setData(response.data)
    setError(null)
  } catch (err) {
    setError(err instanceof Error ? err.message : 'Failed to fetch data')
  } finally {
    setLoading(false)
    setRefreshing(false)
  }
}
